exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".LoginForm__LoginForm__2l5m6 input {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    width: 100%;\n}\n\n.LoginForm__LoginForm__2l5m6 label {\n    margin-right: 1rem;\n}\n\n.LoginForm__LoginForm__2l5m6 button {\n    margin-right: 1rem;\n}\n\n.LoginForm__checkbox__rTItw {\n    margin-bottom: 1rem;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: start;\n        justify-content: start;\n}\n\ninput.LoginForm__form-error__q7jJY {\n    border-color: #f34672;\n    color: #68323f;\n}\n\n.LoginForm__errors__38lPK ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    text-align: left;\n    color: #f34672;\n    margin-bottom: 1rem;\n}", ""]);

// exports
exports.locals = {
	"LoginForm": "LoginForm__LoginForm__2l5m6",
	"checkbox": "LoginForm__checkbox__rTItw",
	"form-error": "LoginForm__form-error__q7jJY",
	"errors": "LoginForm__errors__38lPK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/User/Login/Form/LoginForm.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/User/Login/Form/LoginForm.css
// module chunks = 0